export default {
  loading: (state) => state.loading.isVisible,
  alerts: (state) => state.alerts,
  signatoryFromDeskRhEmpCreation: (state) => state.signatoryFromDeskRhEmpCreation,
};
